module.exports = __webpack_public_path__ + "static/media/footwear-1.48254365.jpg";